import React, {useContext} from 'react'
import styled from "styled-components";
import {StakeCardsTop} from "./stake_cards_top";
import staking from "../../../assets/img/staking_dow.png";
import Spacer from "../../../components/Spacer";
import {StakeList} from "./stake_list";
import BigNumber from "bignumber.js";
import {StakeTopProvider} from "../../../contexts/farm_provider/stake_top_provider";
import StakeCardHook from "../../../hooks/stake_card_hook";
import {UserAccoutProvider} from "../../../contexts/farm_provider/user_account_provider";
import {Context as FarmsContext} from "../../../contexts/Farms";

export const StakeCards: React.FC = () => {



    const {farms} = useContext(FarmsContext);

    const  {farmModel,listCell} = StakeCardHook();

    return (
        <UserAccoutProvider farms={farms}>
            <StyleStakeTop>
                <StakeTopProvider model={farmModel}>
                    <StakeCardsTop stakedLength={listCell.length}/>
                </StakeTopProvider>

                <Spacer/>
                <Spacer/>


                <StakeList listCell={listCell}/>
            </StyleStakeTop>
        </UserAccoutProvider>


    );
};




const StyleStakeTop = styled.div`
width: 1000px;
margin: 0 auto;
@media (max-width: 768px) {
     
      width: 94%;
      margin: 0 auto;

    }
`;
